import { Address, getAddress, isAddress } from "viem";
import { Chain } from "viem/chains";
import { GlobalStore, Receiver } from "../store/global/GlobalStore";
import { isEthereumNetwork } from "./chainUtils";

export enum SliceAddressTypes {
  "Long" = "Long",
  "Medium" = "Medium",
  "Short" = "Short",
}

export const sliceAddress = (type: SliceAddressTypes, address: string) => {
  if (type === SliceAddressTypes.Long) {
    return address.slice(0, 13) + "…" + address.slice(address.length - 15, address.length);
  } else if (type === SliceAddressTypes.Medium) {
    return address.slice(0, 9) + "…" + address.slice(address.length - 8, address.length);
  } else if (type === SliceAddressTypes.Short) {
    return address.slice(0, 5) + "…" + address.slice(address.length - 4, address.length);
  }
  return address.slice(0, 9) + "…" + address.slice(address.length - 8, address.length);
};
export const placeholderText = (network: Chain) => {
  if (isEthereumNetwork(network)) {
    return `Recipient ${network.name} address or ENS`;
  } else {
    return `Recipient ${network.name} address`;
  }
};

export const isReceiverValid = (receiver: Receiver, userAddress: string, userEns: string) => {
  const validAddress = isAddress(receiver.userInput) && receiver.userInput !== userAddress;
  const validEns = receiver.userInput !== userEns;

  if (receiver.userInput.endsWith(".eth")) {
    return validEns;
  }

  return validAddress;
};

export const resetReceiver = () => {
  return GlobalStore.update(s => {
    s.receiverError = "";
    s.receiver = INITIAL_RECEIVER_STATE;
  });
};

export const transformQuoteReceiver = (quoteReceiver: Address, receiver: Receiver): Receiver => {
  const newReceiver = {
    address: quoteReceiver,
    ensName: receiver.ensName ?? "",
    avatar: receiver.avatar ?? "",
    userInput: receiver.userInput,
    isAddressLoading: receiver.isAddressLoading,
  };
  return newReceiver;
};
export const INITIAL_RECEIVER_STATE = {
  ensName: "",
  address: "",
  avatar: "",
  userInput: "",
  isAddressLoading: false,
};

export function isValidChecksumAddress(address: string) {
  return isAddress(address) && address === getAddress(address);
}
